import { Injectable } from '@angular/core';
import {Jsonp, Http, Headers, URLSearchParams, Response} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

/*
service module for loading application settings
*/
@Injectable()
export class SettingsService {

 constructor(private http:Http) {
  }

  getAppSettings():any {
    return this.http.get('data/settings.json').map(res => res.json());
  }
}


// WEBPACK FOOTER //
// ./app/shared/settings/settings.service.ts